import { render, staticRenderFns } from "./ContractSignIdentitiesManagement.vue?vue&type=template&id=36d06025&scoped=true"
import script from "./ContractSignIdentitiesManagement.vue?vue&type=script&lang=js"
export * from "./ContractSignIdentitiesManagement.vue?vue&type=script&lang=js"
import style0 from "./ContractSignIdentitiesManagement.vue?vue&type=style&index=0&id=36d06025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d06025",
  null
  
)

export default component.exports